module.exports = __webpack_public_path__ + "static/img/logo-vertical-minjus-2021.8e8dc08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-vertical-minjus-2021.png
// module id = zGBh
// module chunks = 9